/**
 * Created by vladislav on 1/11/2024
 */

const BasePlugin = function (pluginType, pluginName, options) {
    options = options || {};

    this.bus = new ConnectorEventEmitter();

    this.pluginType = pluginType;
    this.pluginName = pluginName;
    this.sdk = options.sdk;

    this.status = undefined;
};

BasePlugin.prototype.onCreated = function () {

};

BasePlugin.prototype.onRemoved = function () {

};

BasePlugin.prototype.canConnect = function () {
    return true;
};

BasePlugin.prototype.connect = function () {
    if (this.connecting || this.isConnected()) {
        return;
    }

    if (!this.canConnect()) {
        return;
    }

    this.connecting = true;

    console.log("[connector] connecting", this.pluginType, this.pluginName);

    const tasks = this._listConnectTasks();

    let status = connector.STATUS_CONNECTED;
    let reason;

    const onComplete = connector.utils.wait(tasks.length, () => {
        this.connecting = false;

        this.setStatus(status, reason);
        if (status === connector.STATUS_CONNECTED) {
            this.onConnected();
        }
    });

    const onTaskFinished = function (taskStatus, taskReason) {
        taskStatus = taskStatus || connector.STATUS_DISCONNECTED;

        if (taskStatus !== connector.STATUS_CONNECTED) {
            status = taskStatus;
        }

        reason = taskReason || reason;

        onComplete(status, reason);
    };

    tasks.forEach((task) => {
        task(onTaskFinished);
    });
};

BasePlugin.prototype.loadSdkAndConnect = function (callback) {
    if (this.sdk) {
        if (!this.sdkEventHandler) {
            this.sdkEventHandler = connector.sdk.on(this.sdk, this.onSdkEvent.bind(this));
        }

        connector.sdk.loadSdk(this.sdk, (code) => {
            if (code === connector.CODE_SUCCEED) {
                this._connect(connector.utils.waitNoMore(BasePlugin.CONNECT_TIMEOUT, callback));
            } else {
                callback(connector.STATUS_DISCONNECTED);
            }
        });
    } else {
        this._connect(connector.utils.waitNoMore(BasePlugin.CONNECT_TIMEOUT, callback));
    }
};

BasePlugin.prototype._listConnectTasks = function () {
    return [
        this.loadSdkAndConnect.bind(this)
    ];
};

BasePlugin.prototype._connect = function (callback) {
    callback(connector.STATUS_CONNECTED);
};

BasePlugin.prototype.onConnected = function () {

};

BasePlugin.prototype.disconnect = function () {
    this.setStatus(connector.STATUS_DISCONNECTED);
};

BasePlugin.prototype.setStatus = function (status, reason) {
    if (this.status === status) {
        return;
    }

    console.log("[connector] setStatus", this.pluginType, this.pluginName, status);

    this.status = status;

    if (this.status === connector.STATUS_DISCONNECTED) {
        if (this.sdkEventHandler) {
            this.sdkEventHandler.clear();
            this.sdkEventHandler = undefined;
        }
    }

    this.bus.trigger("changeStatus", this.status, reason);
};

BasePlugin.prototype.isConnected = function () {
    return this.status === connector.STATUS_CONNECTED;
};

BasePlugin.prototype.whenConnected = function (callback) {
    if (this.isConnected()) {
        callback();
    } else {
        const listener = this.bus.on("changeStatus", (status) => {
            if (status === connector.STATUS_CONNECTED) {
                listener.clear();
                callback();
            }
        });
        return listener;
    }
};

BasePlugin.prototype.onSdkEvent = function () {
    
};

BasePlugin.prototype.oneOf = function (arr, ...args) {
    arr = Array.isArray(arr) ? arr : [arr, ...args];

    if (arr.some((name) => !name || typeof name !== "string")) {
        throw "Invalid plugin name";
    }

    return arr.includes(this.pluginName);
};

BasePlugin.CONNECT_TIMEOUT = connector.utils.parseInterval("10 seconds");